export const LOGO_BLOCK_RENDER_FEATURE_KEY = "logo";
export const LOGO_BLOCK_RENDER_FEATURE_PATH = "info.children.logo";

export const SUPPORT_INFO_RENDER_FEATURE_KEY = "support";
export const SUPPORT_INFO_RENDER_FEATURE_PATH = "info.children.support";
